var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeMargin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2630_27392)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    transform: "translate(0.425781 0.700195)",
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.425781 33.7002H33.4258V0.700195H0.425781V33.7002Z",
    fill: "#F3F4F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2630_27392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4258 0.700195H0.425781V33.7002H33.4258V0.700195Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2630_27392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.69629 20.8428C5.69629 21.9473 6.59172 22.8428 7.69629 22.8428H24.6963C25.8009 22.8428 26.6963 21.9473 26.6963 20.8428V12.8428C26.6963 11.7382 25.8009 10.8428 24.6963 10.8428H7.69629C6.59172 10.8428 5.69629 11.7382 5.69629 12.8428V20.8428Z",
    fill: "#666666"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2630_27392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.425781 0.700195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeMargin);
export default __webpack_public_path__ + "static/media/large-margin.c669d9f0fcb76f9bb7ff7ce571e62f3a.svg";
export { ForwardRef as ReactComponent };